module.exports = __webpack_public_path__ + "static/media/Why Choose 6.fca20687.png";